import { Link } from 'react-router-dom';
import { Layout, Menu, Card, Space, Row, Col, Typography } from 'antd';
import {
  HomeOutlined,
  PhoneOutlined,
  MailOutlined,
  UserOutlined,
  FileTextOutlined,
  ToolOutlined,
  FileProtectOutlined,
  ContainerOutlined,
} from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import './menu-sider.scss';
import CanShow from '../../can-show';
import { useEpicorCustomer } from '../../../hooks';
import { formatPhoneNumber } from '../../../utils/general';

const MenuSider = ({
  menuCollapsed,
  roles = [],
}: {
  menuCollapsed: boolean | undefined;
  roles: string[];
}) => {
  const { customer } = useEpicorCustomer();
  const { Sider } = Layout;
  const location = useLocation();
  const { Paragraph } = Typography;

  return (
    <Sider
      className="admin-sider"
      collapsed={menuCollapsed}
      collapsible
      breakpoint="md"
      collapsedWidth="0"
      width={220}
      style={{ position: 'fixed' }}
    >
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={[location.pathname]}
        selectedKeys={[location.pathname]}
      >
        <Menu.Item key="/">
          <Link to="/">
            <HomeOutlined />
            <span className="nav-text">Inicio</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="/facturacion">
          <Link to="/facturacion">
            <FileProtectOutlined />
            <span className="nav-text">Facturación</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="/antiguedad-saldos">
          <Link to="/antiguedad-saldos">
            <FileTextOutlined />
            <span className="nav-text">Antigüedad de saldos</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="/backorders">
          <Link to="/backorders">
            <ContainerOutlined />
            <span className="nav-text">Backorders</span>
          </Link>
        </Menu.Item>
        {/* <CanShow roles={['Customer']}>
          <Menu.Item key="/suppliers" style={{ marginLeft: 28 }}>
            <Link to="/suppliers">
              <UserOutlined />
              <span className="nav-text">Proveedores</span>
            </Link>
          </Menu.Item>
        </CanShow> */}
        <Menu.Item key="/administration">
          <CanShow roles={['ADMIN']}>
            <Link to="/administration">
              <ToolOutlined />
              <span className="nav-text">Administración</span>
            </Link>
          </CanShow>
        </Menu.Item>
        <CanShow roles={['CUSTOMER']}>
          <>
            <Space direction="vertical" size={10} className="space-complete">
              <Card
                headStyle={{ color: 'rgba(255, 255, 255, 0.65)' }}
                size="small"
                title="Ejecutivo de cobranza"
                className="agent-card"
              >
                <p>Nombre: {customer?.salesRep_BillingAgent_Name}</p>
                <p>
                  Teléfono: {customer?.salesRep_BillingAgent_OfficePhoneNum}
                </p>
                <p>Correo: {customer?.salesRep_BillingAgent_EMailAddress}</p>
              </Card>
              <Card
                headStyle={{ color: 'rgba(255, 255, 255, 0.65)' }}
                size="small"
                title="Agente de ventas"
                className="agent-card"
              >
                <p>Nombre: {customer?.salesRep_Name}</p>
                <p>Teléfono: {customer?.salesRep_CellPhoneNum}</p>
                <p>Correo: {customer?.salesRep_EMailAddress}</p>
              </Card>
            </Space>
            {/* <div className="menu-extra">
              <div className="menu-info">
                <Row style={{ justifyContent: 'center' }}>
                  <Space size={5} align="baseline">
                    <PhoneOutlined />
                    <Paragraph>
                      Tel. {''}
                      {customer &&
                        formatPhoneNumber(
                          parseInt(customer.salesRep_CellPhoneNum)
                        )}
                    </Paragraph>
                  </Space>
                </Row>
              </div>
              <div className="menu-info">
                <Col style={{}}>
                  <Row style={{ justifyContent: 'center' }}>
                    <MailOutlined style={{ marginTop: 3 }} />
                    <Paragraph style={{ marginLeft: 5 }}>
                      Agente de ventas
                    </Paragraph>
                  </Row>
                  <Col>
                    <Paragraph>{customer?.salesRep_Name}</Paragraph>
                  </Col>
                </Col>
                <Row style={{ justifyContent: 'center' }}>
                  <div style={{ width: 190 }}>
                    <Paragraph>{customer?.salesRep_EMailAddress}</Paragraph>
                  </div>
                </Row>
              </div>
            </div> */}
          </>
        </CanShow>
      </Menu>
    </Sider>
  );
};

export default MenuSider;
